export const GET_LENDERS = 'GET_LENDERS';
export const GET_LENDERS_SUCCESS = 'GET_LENDERS_SUCCESS';
export const GET_LENDERS_FAILURE = 'GET_LENDERS_FAILURE';

export const GET_LENDER = 'GET_LENDER';
export const GET_LENDER_SUCCESS = 'GET_LENDER_SUCCESS';
export const GET_LENDER_FAILURE = 'GET_LENDER_FAILURE';